const videoModal = document.querySelector('[data-video-modal]');
const videoModalFrame = document.querySelector('[data-video-modal-frame]');
const videoModalPanel = document.querySelector('[data-video-modal-panel]');
const videoModalCloseButtons = document.querySelectorAll(
    '[data-video-modal-close]',
);
const videoModalOpenButtons = document.querySelectorAll(
    '[data-video-modal-open]',
);

const concertInfoModal = document.querySelector('[data-concert-info-modal]');
const concertInfoModalPanel = concertInfoModal?.querySelector(
    '[data-concert-info-panel]',
);
const concertInfoModalTitle = concertInfoModal?.querySelector(
    '[data-concert-info-modal-title]',
);
const concertInfoModalVenue = concertInfoModal?.querySelector(
    '[data-concert-info-venue]',
);
const concertInfoModalLocation = concertInfoModal?.querySelector(
    '[data-concert-info-location]',
);
const concertInfoModalDateTime = concertInfoModal?.querySelector(
    '[data-concert-info-datetime]',
);
const concertInfoModalDescription = concertInfoModal?.querySelector(
    '[data-concert-info-body]',
);
const concertInfoModalTicketLink = concertInfoModal?.querySelector(
    '[data-concert-info-ticket]',
);
const concertInfoModalCloseButtons = document.querySelectorAll(
    '[data-concert-info-close]',
);
const concertInfoModalOpenButtons = document.querySelectorAll(
    '[data-concert-info-open]',
);

const buildEmbedUrl = (url) => {
    if (!url) {
        return '';
    }

    try {
        const parsedUrl = new URL(url, window.location.origin);
        const hostname = parsedUrl.hostname.replace('www.', '');

        if (hostname === 'youtu.be') {
            return `https://www.youtube.com/embed/${parsedUrl.pathname.slice(1)}`;
        }

        if (hostname.includes('youtube.com')) {
            const id = parsedUrl.searchParams.get('v');

            if (id) {
                return `https://www.youtube.com/embed/${id}`;
            }
        }

        if (hostname.includes('vimeo.com')) {
            const segments = parsedUrl.pathname.split('/').filter(Boolean);
            const id = segments[segments.length - 1];

            if (id) {
                return `https://player.vimeo.com/video/${id}`;
            }
        }

        return url;
    } catch {
        return url;
    }
};

const toggleVideoModal = (isOpen, url = '') => {
    if (!videoModal || !videoModalFrame || !videoModalPanel) {
        return;
    }

    if (isOpen) {
        videoModalFrame.src = buildEmbedUrl(url);
        videoModal.classList.remove('hidden');
        document.documentElement.classList.add('overflow-hidden');

        requestAnimationFrame(() => {
            videoModal.classList.remove('opacity-0');
            videoModalPanel.classList.remove('opacity-0', 'scale-95');
        });

        videoModal.setAttribute('aria-hidden', 'false');
        return;
    }

    videoModal.classList.add('opacity-0');
    videoModalPanel.classList.add('opacity-0', 'scale-95');
    document.documentElement.classList.remove('overflow-hidden');
    videoModal.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
        videoModal.classList.add('hidden');
        videoModalFrame.src = '';
    }, 300);
};

videoModalOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const url = button.dataset.videoUrl;
        toggleVideoModal(true, url);
    });
});

videoModalCloseButtons.forEach((button) => {
    button.addEventListener('click', () => toggleVideoModal(false));
});

if (videoModal) {
    videoModal.addEventListener('click', (event) => {
        if (event.target === videoModal) {
            toggleVideoModal(false);
        }
    });
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        toggleVideoModal(false);
    }
});

const toggleConcertInfoModal = (
    isOpen,
    title = '',
    description = '',
    button = null,
) => {
    if (
        !concertInfoModal ||
        !concertInfoModalPanel ||
        !concertInfoModalTitle ||
        !concertInfoModalDescription
    ) {
        return;
    }

    if (isOpen) {
        concertInfoModalTitle.textContent = title;
        concertInfoModalDescription.textContent = description;
        concertInfoModalVenue.textContent =
            button?.dataset?.concertInfoVenue ?? '';
        concertInfoModalLocation.textContent =
            button?.dataset?.concertInfoLocation ?? '';
        concertInfoModalDateTime.textContent = [
            button?.dataset?.concertInfoDate ?? '',
            button?.dataset?.concertInfoTime ?? '',
        ]
            .filter(Boolean)
            .join(' · ');
        const ticketUrl = button?.dataset?.concertInfoTicketUrl ?? '';

        if (concertInfoModalTicketLink) {
            concertInfoModalTicketLink.href = ticketUrl;
            concertInfoModalTicketLink.classList.toggle('hidden', !ticketUrl);
        }
        concertInfoModal.classList.remove('hidden');
        document.documentElement.classList.add('overflow-hidden');

        requestAnimationFrame(() => {
            concertInfoModal.classList.remove('opacity-0');
            concertInfoModalPanel.classList.remove('opacity-0', 'scale-95');
        });

        concertInfoModal.setAttribute('aria-hidden', 'false');
        return;
    }

    concertInfoModal.classList.add('opacity-0');
    concertInfoModalPanel.classList.add('opacity-0', 'scale-95');
    document.documentElement.classList.remove('overflow-hidden');
    concertInfoModal.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
        concertInfoModal.classList.add('hidden');
        concertInfoModalTitle.textContent = '';
        if (concertInfoModalVenue) {
            concertInfoModalVenue.textContent = '';
        }
        if (concertInfoModalLocation) {
            concertInfoModalLocation.textContent = '';
        }
        if (concertInfoModalDateTime) {
            concertInfoModalDateTime.textContent = '';
        }
        concertInfoModalDescription.textContent = '';
        if (concertInfoModalTicketLink) {
            concertInfoModalTicketLink.href = '';
            concertInfoModalTicketLink.classList.add('hidden');
        }
    }, 300);
};

concertInfoModalOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const title = button.dataset.concertInfoTitle ?? '';
        const description = button.dataset.concertInfoDescription ?? '';

        if (!description) {
            return;
        }

        toggleConcertInfoModal(true, title, description, button);
    });
});

concertInfoModalCloseButtons.forEach((button) => {
    button.addEventListener('click', () => toggleConcertInfoModal(false));
});

if (concertInfoModal) {
    concertInfoModal.addEventListener('click', (event) => {
        if (event.target === concertInfoModal) {
            toggleConcertInfoModal(false);
        }
    });
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        toggleConcertInfoModal(false);
    }
});

const imageModal = document.querySelector('[data-image-modal]');
const imageModalPanel = document.querySelector('[data-image-modal-panel]');
const imageModalImage = document.querySelector('[data-image-modal-image]');
const imageModalPrevButton = document.querySelector('[data-image-modal-prev]');
const imageModalNextButton = document.querySelector('[data-image-modal-next]');
const imageModalCloseButtons = document.querySelectorAll(
    '[data-image-modal-close]',
);
const imageModalOpenButtons = document.querySelectorAll(
    '[data-image-modal-open]',
);
let imageModalGallery = [];
let imageModalIndex = 0;

const updateImageModalNavigationVisibility = (isVisible) => {
    [imageModalPrevButton, imageModalNextButton].forEach((button) => {
        if (!(button instanceof HTMLElement)) {
            return;
        }

        button.style.display = isVisible ? 'flex' : 'none';
    });
};

const toggleImageModal = (isOpen, url = '', alt = '') => {
    if (!imageModal || !imageModalPanel || !imageModalImage) {
        return;
    }

    if (isOpen) {
        imageModalImage.src = url;
        imageModalImage.alt = alt;
        imageModal.classList.remove('hidden');
        document.documentElement.classList.add('overflow-hidden');

        requestAnimationFrame(() => {
            imageModal.classList.remove('opacity-0');
            imageModalPanel.classList.remove('opacity-0', 'scale-95');
        });

        imageModal.setAttribute('aria-hidden', 'false');
        return;
    }

    imageModal.classList.add('opacity-0');
    imageModalPanel.classList.add('opacity-0', 'scale-95');
    document.documentElement.classList.remove('overflow-hidden');
    imageModal.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
        imageModal.classList.add('hidden');
        imageModalImage.src = '';
        imageModalImage.alt = '';
    }, 300);
};

imageModalOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const group = button.dataset.imageGroup ?? 'default';
        const groupButtons = Array.from(
            document.querySelectorAll(
                `[data-image-modal-open][data-image-group="${group}"]`,
            ),
        );
        imageModalGallery = groupButtons.map((item) => {
            const img = item.querySelector('img');

            return {
                url: item.dataset.imageUrl ?? '',
                alt: img?.getAttribute('alt') ?? '',
            };
        });
        imageModalIndex = groupButtons.indexOf(button);

        const current = imageModalGallery[imageModalIndex];
        toggleImageModal(true, current?.url ?? '', current?.alt ?? '');
        const shouldShowNav = imageModalGallery.length > 1;
        updateImageModalNavigationVisibility(shouldShowNav);
    });
});

imageModalCloseButtons.forEach((button) => {
    button.addEventListener('click', () => toggleImageModal(false));
});

if (imageModal) {
    imageModal.addEventListener('click', (event) => {
        if (event.target === imageModal) {
            toggleImageModal(false);
        }
    });
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        toggleImageModal(false);
    }
});

const goToImage = (direction) => {
    if (!imageModalGallery.length) {
        return;
    }

    imageModalIndex =
        (imageModalIndex + direction + imageModalGallery.length) %
        imageModalGallery.length;
    const current = imageModalGallery[imageModalIndex];

    if (current) {
        imageModalImage.src = current.url;
        imageModalImage.alt = current.alt;
    }
};

imageModalPrevButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    goToImage(-1);
});

imageModalNextButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    goToImage(1);
});

document.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
        goToImage(-1);
    }

    if (event.key === 'ArrowRight') {
        goToImage(1);
    }
});

const bandPlaceTheme = window.BandPlaceTheme || {};

const shopCart = (() => {
    const storageKey = (host = window.location.host) => `shop-cart:${host}`;

    const isValidItemShape = (item) => {
        if (!item || typeof item !== 'object') {
            return false;
        }

        if (!item.id || !item.name || !item.type) {
            return false;
        }

        return Number.isFinite(Number(item.price));
    };

    const toValidIdSet = (validProductIds) => {
        if (!Array.isArray(validProductIds) || validProductIds.length === 0) {
            return null;
        }

        return new Set(validProductIds.map((id) => String(id)));
    };

    const normalize = (payload, validProductIds = null) => {
        const validIdSet = toValidIdSet(validProductIds);
        const cart = new Map();

        if (!Array.isArray(payload)) {
            return cart;
        }

        payload.forEach((item) => {
            if (!isValidItemShape(item)) {
                return;
            }

            const id = String(item.id);

            if (validIdSet && !validIdSet.has(id)) {
                return;
            }

            const quantity = Number(item.quantity);
            const normalizedQuantity = Number.isFinite(quantity)
                ? Math.floor(quantity)
                : 0;

            if (normalizedQuantity <= 0) {
                return;
            }

            const normalizedItem = {
                id,
                name: String(item.name),
                type: String(item.type),
                price: Number(item.price),
                quantity: normalizedQuantity,
            };

            const existing = cart.get(id);

            if (existing) {
                existing.quantity += normalizedItem.quantity;
                return;
            }

            cart.set(id, normalizedItem);
        });

        return cart;
    };

    const persist = (cart, key = storageKey()) => {
        const payload = Array.from(cart.values());
        window.localStorage.setItem(key, JSON.stringify(payload));
    };

    const load = ({ validProductIds = null, key = storageKey() } = {}) => {
        let payload;

        try {
            payload = JSON.parse(window.localStorage.getItem(key) || '[]');
        } catch {
            payload = [];
        }

        const normalizedCart = normalize(payload, validProductIds);
        persist(normalizedCart, key);

        return normalizedCart;
    };

    const countItems = (cart) =>
        Array.from(cart.values()).reduce(
            (total, item) => total + Number(item.quantity || 0),
            0,
        );

    const readValidProductIdsFromRoot = (root) => {
        if (!(root instanceof HTMLElement)) {
            return null;
        }

        const raw = root.getAttribute('data-shop-valid-product-ids');

        if (!raw) {
            return null;
        }

        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : null;
        } catch {
            return null;
        }
    };

    const loadFromElement = (root) =>
        load({ validProductIds: readValidProductIdsFromRoot(root) });

    const add = (cart, item) => {
        if (!isValidItemShape(item)) {
            return;
        }

        const id = String(item.id);
        const existing = cart.get(id);

        if (existing) {
            existing.quantity += 1;
            return;
        }

        cart.set(id, {
            id,
            name: String(item.name),
            type: String(item.type),
            price: Number(item.price),
            quantity: 1,
        });
    };

    return {
        storageKey,
        normalize,
        load,
        loadFromElement,
        persist,
        countItems,
        readValidProductIdsFromRoot,
        add,
    };
})();

const shopUi = (() => {
    const parseProductFromButton = (button) => {
        if (!(button instanceof HTMLElement)) {
            return null;
        }

        const id = button.getAttribute('data-product-id');
        const name = button.getAttribute('data-product-name');
        const type = button.getAttribute('data-product-type');
        const price = Number(button.getAttribute('data-product-price') || 0);

        if (!id || !name || !type || !Number.isFinite(price)) {
            return null;
        }

        return { id, name, type, price };
    };

    const resolveActionId = (target, action) => {
        if (!(target instanceof Element)) {
            return null;
        }

        const trigger = target.closest(`[data-shop-${action}]`);
        if (!trigger) {
            return null;
        }

        return trigger.getAttribute(`data-shop-${action}`);
    };

    const initCatalogPage = ({
        root,
        cartLabelFormatter = (count) => `Cart (${count})`,
        onItemAdded = null,
    }) => {
        if (!(root instanceof HTMLElement)) {
            return null;
        }

        const cart = shopCart.loadFromElement(root);
        const viewCartButton = root.querySelector('[data-shop-view-cart]');

        const updateViewCartButton = () => {
            if (!(viewCartButton instanceof HTMLElement)) {
                return;
            }

            viewCartButton.textContent = cartLabelFormatter(
                shopCart.countItems(cart),
            );
        };

        root.querySelectorAll('[data-shop-add]').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                const product = parseProductFromButton(button);
                if (!product) {
                    return;
                }

                shopCart.add(cart, product);
                shopCart.persist(cart);
                updateViewCartButton();

                if (typeof onItemAdded === 'function') {
                    onItemAdded({
                        button,
                        product,
                        cart,
                        itemCount: shopCart.countItems(cart),
                    });
                }
            });
        });

        updateViewCartButton();

        return {
            cart,
            updateViewCartButton,
        };
    };

    const initCheckoutPage = ({
        root,
        currency,
        rowRenderer,
        emptyStateClass,
        emptyStateText = 'No items selected.',
        requiredShippingFields = [
            'shipping_country',
            'shipping_recipient',
            'shipping_line_1',
            'shipping_city',
            'shipping_postal_code',
        ],
    }) => {
        if (!(root instanceof HTMLElement)) {
            return null;
        }

        const cart = shopCart.loadFromElement(root);
        const list = root.querySelector('[data-shop-cart-list]');
        const total = root.querySelector('[data-shop-cart-total]');
        const submit = root.querySelector('[data-shop-submit]');
        const shipping = root.querySelector('[data-shop-shipping]');
        const shippingInputs = shipping
            ? Array.from(shipping.querySelectorAll('input, select'))
            : [];
        const itemsContainer = root.querySelector('[data-shop-items-inputs]');
        const form = root.querySelector('[data-shop-form]');

        if (
            new URLSearchParams(window.location.search).get('checkout') ===
            'success'
        ) {
            cart.clear();
            window.localStorage.removeItem(shopCart.storageKey());
        }

        const persist = () => {
            shopCart.persist(cart);
        };

        const render = () => {
            const items = Array.from(cart.values()).filter(
                (item) => item.quantity > 0,
            );
            const subtotal = items.reduce(
                (sum, item) => sum + item.price * item.quantity,
                0,
            );
            const requiresShipping = items.some(
                (item) => item.type === 'physical',
            );

            if (list) {
                list.innerHTML = '';

                if (items.length === 0) {
                    const empty = document.createElement('p');
                    if (emptyStateClass) {
                        empty.className = emptyStateClass;
                    }
                    empty.textContent = emptyStateText;
                    list.appendChild(empty);
                } else {
                    items.forEach((item) => {
                        if (typeof rowRenderer !== 'function') {
                            return;
                        }

                        const row = rowRenderer(item, { currency });

                        if (row instanceof HTMLElement) {
                            list.appendChild(row);
                        }
                    });
                }
            }

            if (total) {
                total.textContent = `${(subtotal / 100).toFixed(2)} ${currency}`;
            }

            if (submit) {
                submit.disabled = items.length === 0;
            }

            if (shipping) {
                shipping.classList.toggle('hidden', !requiresShipping);
            }

            shippingInputs.forEach((input) => {
                input.required =
                    requiresShipping &&
                    requiredShippingFields.includes(input.name);
            });

            persist();
        };

        if (list) {
            list.addEventListener('click', (event) => {
                const target = event.target;

                const plusId = resolveActionId(target, 'plus');
                const minusId = resolveActionId(target, 'minus');
                const removeId = resolveActionId(target, 'remove');

                if (plusId && cart.has(plusId)) {
                    cart.get(plusId).quantity += 1;
                    render();
                    return;
                }

                if (minusId && cart.has(minusId)) {
                    const item = cart.get(minusId);
                    item.quantity -= 1;

                    if (item.quantity <= 0) {
                        cart.delete(minusId);
                    }

                    render();
                    return;
                }

                if (removeId && cart.has(removeId)) {
                    cart.delete(removeId);
                    render();
                }
            });
        }

        if (form && itemsContainer) {
            form.addEventListener('submit', () => {
                itemsContainer.innerHTML = '';

                Array.from(cart.values()).forEach((item, index) => {
                    const idInput = document.createElement('input');
                    idInput.type = 'hidden';
                    idInput.name = `items[${index}][product_id]`;
                    idInput.value = item.id;

                    const quantityInput = document.createElement('input');
                    quantityInput.type = 'hidden';
                    quantityInput.name = `items[${index}][quantity]`;
                    quantityInput.value = String(item.quantity);

                    itemsContainer.appendChild(idInput);
                    itemsContainer.appendChild(quantityInput);
                });

                persist();
            });
        }

        render();

        return {
            cart,
            render,
        };
    };

    return {
        initCatalogPage,
        initCheckoutPage,
    };
})();

bandPlaceTheme.cart = shopCart;
bandPlaceTheme.shop = shopUi;
window.BandPlaceTheme = bandPlaceTheme;
